import { Fragment } from 'react';
import { LinkableEntityType } from '@api';
import { ArtistAnchor } from '@common';
import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type CoHeadlinerTableCellPropsType = {
  coHeadliners: LinkableEntityType[];
};

export const CoHeadlinerTableCell: React.FC<CoHeadlinerTableCellPropsType> = ({
  coHeadliners,
}) => {
  const { t } = useTranslation('common');

  if (coHeadliners.length === 0) {
    return t('NO_DATA_PLACEHOLDER');
  }

  return (
    <Text>
      {coHeadliners.map((coHeadliner, index) => (
        <Fragment key={coHeadliner.id}>
          <ArtistAnchor artist={coHeadliner} />
          {index < coHeadliners.length - 1 && ' & '}
        </Fragment>
      ))}
    </Text>
  );
};
